import * as yup from 'yup';
import { validateText } from 'utils/validation';
import { CreateEnvironmentForm } from './types';

export const environmentValidationSchema = yup.object().shape({
  name: validateText(),
  // The API requires a valid URI for baseUrl
  baseUrl: yup.string().url('Invalid URL format')
});

/**
 * Generates the form used to create a new environment.
 */
export const getCreateEnvironmentForm = (): CreateEnvironmentForm => ({
  name: {
    error: null,
    initialValue: '',
    propertyPath: 'name',
    readOnly: false,
    shouldParse: false,
    value: ''
  },
  integrationId: {
    error: null,
    initialValue: '',
    propertyPath: 'integrationId',
    readOnly: false,
    shouldParse: false,
    value: ''
  },
  baseUrl: {
    error: null,
    initialValue: '',
    propertyPath: 'baseUrl',
    readOnly: false,
    shouldParse: false,
    value: ''
  }
});
